export const isInView = (elm, visibilityFactor = 1) => {
    const elmDimensions = elm.getBoundingClientRect();
    const elementVisibilityAmount = elm.offsetHeight / visibilityFactor;

    return (
        elmDimensions.width > 0
        && elmDimensions.height > 0
        && elmDimensions.top >= 0
        && elmDimensions.left >= 0
        && elmDimensions.bottom - elementVisibilityAmount <= (window.innerHeight || document.documentElement.clientHeight)
        && elmDimensions.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
};
